import { getRecieverFactoringRequestOverview } from 'lib/api/factoring';
import SharedEvaluationNodesPage from 'pages/mobile/Finance/shared/EvaluationNodesPage';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const FactoringEvaluationNodesPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { data: overview } = getRecieverFactoringRequestOverview(dispatch, {
    requestId: id ?? '',
  });
  const quoteId = overview?.quoteId ?? null;
  return (
    <SharedEvaluationNodesPage
      product="factoring"
      quoteId={overview !== undefined ? quoteId : undefined}
    />
  );
};

export default FactoringEvaluationNodesPage;
